//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
/** Components Import */
import M_TBS_CUSTOM from './M_TBS_CUSTOM';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Services Import */
import Global from '../../../../Services/Common/Global';
/** Query */
import {
  useSearch1,
  useSearch2,
  useSearch3,
  useSearch4,
  useSearch5,
  useSearch6,
  useSearch7,
  useSave1,
  useSave2,
} from './M_TBS_CUSTOM_Query';
import { useSave } from '../../../../Hooks/useSave';
import { NavBarInfoActions } from '../../../../Reducer/NavBarInfoReducer';
import { TbmActions } from '../../../../Reducer/TbmReducer';
import Commons from '../../../../Services/Common/Common';
import { useBackStack } from '../../../../Hooks/back/useBackStack';
//#endregion

function M_TBS_CUSTOMF(props) {
  //#region 변수
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const codeInfo = useSelector((state) => state.code.codeInfo);
  const { sessionData, stepData } = useSelector((state) => state.tbm);

  const [selectedType, setSelectedType] = useState(null);
  const [listDialogOpen, setListDialogOpen] = useState(false);
  const [listData, setListData] = useState([]);
  const [listTitle, setListTitle] = useState('');
  const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
  const [previewItem, setPreviewItem] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedEducation, setSelectedEducation] = useState(null);
  const [selectedWorkplan, setSelectedWorkplan] = useState(null);
  const [workpermitFlag, setWorkpermitFlag] = useState(null);

  const videoRef = useRef();
  const originPathsRef = useRef(null); // 교육동영상, 교육파일, 작업계획서 초기 경로
  //#endregion

  useBackStack({
    type: 'navigate',
    onBack: () => {
      setSelectedVideo(null);
      setSelectedEducation(null);
      setSelectedWorkplan(null);
      navigate('/Home');
    },
  });

  //#region 이벤트
  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('TBM 자료 선택'));
    Search4Async();
    Search7Async();
  }, [dispatch]);
  //#endregion

  //#region 쿼리
  const { runAsync: Search1Async } = useSearch1({
    onSuccess: (rows) => {
      setListData(rows);
      setListTitle('교육 동영상 선택');
      setListDialogOpen(true);
    },
  });
  const { runAsync: Search2Async } = useSearch2({
    onSuccess: (rows) => {
      setListData(rows);
      setListTitle('교육 파일 선택');
      setListDialogOpen(true);
    },
  });
  const { runAsync: Search3Async } = useSearch3({
    onSuccess: (rows) => {
      // 작업계획서 데이터 처리
      const transformedData = (rows || []).map((item) => ({
        chaebun: item.chaebun,
        createDate: item.createDate,
        createId: item.createId,
        custCd: item.custCd,
        date: item.date,
        fileName: item.fileName,
        filePath: item.filePath,
        saveName: item.saveName,
        updateDate: item.updateDate,
        updateId: item.updateId,
      }));
      setListData(transformedData);
      setListTitle('작업계획서 선택');
      setListDialogOpen(true);
    },
  });
  const { runAsync: Search4Async } = useSearch4({
    onSuccess: (rows) => {
      const data = rows?.[0];

      Search5Async(); // 참석자, 스탭 테이블의 데이터가 비어있을때를 대비해 if문 안에서 빼냄
      // 진행중인 TBM 있는 경우 M_ToolBoxMeeting로 이동 없으면 선택 화면 표시
      if (!data || data.sessionStatus === 'CLOSE') {
        dispatch(TbmActions.setSessionData(data));
        originPathsRef.current = {
          videoPath: data?.videoPath,
          filePath: data?.filePath,
          planPath: data?.planPath,
        };
        setSelectedVideo({
          videoLocation: data?.videoPath,
          videoFileName: data?.videoPath?.split('/')?.pop(),
        });
        setSelectedEducation({
          eduLocation: data?.filePath,
          eduFileName: data?.filePath?.split('/')?.pop(),
        });
        setSelectedWorkplan({
          filePath: data?.planPath,
          fileName: (() => {
            const fullName = data?.planPath?.split('/')?.pop() || '';
            const firstUnderscoreIndex = fullName.indexOf('_');
            if (firstUnderscoreIndex === -1) return fullName;
            return fullName.substring(firstUnderscoreIndex + 1);
          })(),
        });
      } else {
        Search6Async({ sessionCd: data.sessionCd });
      }
    },
  });
  const { runAsync: Search5Async } = useSearch5({
    onSuccess: (rows) => {
      const lastPositionByStep = new Map(
        rows.map((r) => [r.stepCode, r.lastPosition])
      );
      const defaultStepData = codeInfo
        .filter((f) => f.groupCd === 'TBM_STEP')
        .map((item) => ({
          stepOrder: Number(item.val1),
          stepCode: item.code,
          isRequired: 'Y',
          isSkipAllowed: 'Y',
          lastPosition: lastPositionByStep.get(item.code) ?? '0',
        }));
      dispatch(TbmActions.setStepData(defaultStepData));
    },
  });
  const { runAsync: Search6Async } = useSearch6({
    onSuccess: (rows) => {
      console.log(rows);
      if (rows.length > 0) {
        const host = rows.find((f) => f.hostYn === 'Y');
        dispatch(TbmActions.setParticipantData(host));
        navigate('/M_TBMManager');
      }
    },
  });
  const { runAsync: Search7Async } = useSearch7({
    onSuccess: (rows) => {
      // 작업허가서 유무
      setWorkpermitFlag(rows.length > 0);
    },
  });
  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();

  // 저장
  const { run: Save1 } = useSave({
    menuId: 'M_TBS_CUSTOM',
    requestSave: (rows) => Save1Async(rows),
    onSuccess: async (rows) => {
      const data = rows.saveDetailData[0].data[0];
      dispatch(TbmActions.setSessionData(data));

      // 2. TBM 참가자 저장
      const result = await Save2Async([
        {
          sessionCd: data.sessionCd,
          hostYn: 'Y',
          stayTime: 0,
        },
      ]);

      dispatch(TbmActions.setParticipantData(result.data[0].data[0]));

      navigate('/M_TBMManager');
    },
  });

  const SaveLogic1 = async () => {
    try {
      const videoPath = selectedVideo?.videoLocation || '';
      const filePath = selectedEducation?.eduLocation || '';
      const planPath = selectedWorkplan?.filePath || '';
      const workpermit = workpermitFlag;

      // 경로있는 페이지만 필터링
      const includedSteps = stepData.filter((item) => {
        if (item.stepCode === 'TBM_VIDEO' && !videoPath) return false;
        if (item.stepCode === 'TBM_DOCS' && !filePath) return false;
        if (item.stepCode === 'TBM_PLAN' && !planPath) return false;
        if (item.stepCode === 'TBM_PERMIT' && !workpermit) return false;
        return true;
      });

      // 오름차순 정렬
      const orderedIncludedSteps = [...includedSteps].sort(
        (a, b) => Number(a.stepOrder) - Number(b.stepOrder)
      );

      // stepOrder 1부터 순서대로 부여
      // Search4 초기 경로와 다른 단계는 자료가 바뀐 것이므로 lastPosition 0
      const initialPaths = originPathsRef.current;
      const renumberedSteps = orderedIncludedSteps.map((item, index) => {
        let lastPosition = item.lastPosition;

        if (initialPaths) {
          if (
            item.stepCode === 'TBM_VIDEO' &&
            videoPath !== initialPaths.videoPath
          ) {
            lastPosition = '0';
          } else if (
            item.stepCode === 'TBM_DOCS' &&
            filePath !== initialPaths.filePath
          ) {
            lastPosition = '0';
          } else if (
            item.stepCode === 'TBM_PLAN' &&
            planPath !== initialPaths.planPath
          ) {
            lastPosition = '0';
          } else if (
            item.stepCode === 'TBM_PERMIT' &&
            sessionData.sessionStatus === 'CLOSE'
          ) {
            lastPosition = '0';
          }
        }
        return {
          stepOrder: String(index + 1),
          stepCode: item.stepCode,
          isRequired: 'Y',
          isSkipAllowed: 'Y',
          lastPosition,
        };
      });

      const curSteps = renumberedSteps[0];
      const sessionSteps = renumberedSteps.map((item) => ({
        stepOrder: Commons.EncryptAES(item.stepOrder),
        stepCode: Commons.EncryptAES(item.stepCode),
        isRequired: Commons.EncryptAES('Y'),
        isSkipAllowed: Commons.EncryptAES('Y'),
        lastPosition: Commons.EncryptAES(item.lastPosition),
      }));
      dispatch(TbmActions.setStepData(renumberedSteps));

      // 1. TBM 정보 저장
      await Save1([
        {
          curStepOrder: curSteps.stepOrder,
          curStepCode: curSteps.stepCode,
          curPosition: curSteps.lastPosition,
          videoPath: videoPath,
          filePath: filePath,
          planPath: planPath,
          sessionSteps: sessionSteps,
        },
      ]);
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
    }
  };
  //#endregion

  //#region 나머지 함수
  const HandleSelectType = async (type) => {
    setSelectedType(type);
    try {
      if (type === 'video') {
        await Search1Async();
      } else if (type === 'education') {
        await Search2Async();
      } else if (type === 'workplan') {
        await Search3Async();
      }
    } catch (e) {
      console.log(e);
    }
  };

  const HandleSelectItem = (item) => {
    setPreviewItem(item);
    setListDialogOpen(false);
    setPreviewDialogOpen(true);
  };

  const HandleConfirmPreview = (item = null) => {
    if (item === null) {
      if (selectedType === 'video') setSelectedVideo(null);
      else if (selectedType === 'education') setSelectedEducation(null);
      else if (selectedType === 'workplan') setSelectedWorkplan(null);
      return;
    }

    const selectedItem = item || previewItem;

    if (selectedType === 'video') {
      setSelectedVideo(selectedItem);
      dispatch(
        showSnackbar({
          message: '교육 동영상이 선택되었습니다.',
          type: 'success',
        })
      );
    } else if (selectedType === 'education') {
      setSelectedEducation(selectedItem);
      dispatch(
        showSnackbar({
          message: '교육 파일이 선택되었습니다.',
          type: 'success',
        })
      );
    } else if (selectedType === 'workplan') {
      setSelectedWorkplan(selectedItem);
      dispatch(
        showSnackbar({
          message: '작업계획서가 선택되었습니다.',
          type: 'success',
        })
      );
    }

    setPreviewDialogOpen(false);
    setListDialogOpen(false);
    setPreviewItem(null);
  };

  const GetFileUrl = (item, type) => {
    if (!item) return '';
    let filePath = '';
    if (type === 'video') {
      filePath = item.videoLocation || item.videoFilePath || '';
    } else if (type === 'education') {
      filePath = item.eduLocation || item.eduFilePath || '';
    } else if (type === 'workplan') {
      filePath = item.filePath || '';
    }
    if (!filePath) return '';
    if (filePath.startsWith('http')) return filePath;
    const fixedPath = Commons.EncodeUrl(filePath);
    return `${Global.file.useUrl}files/${fixedPath}`;
  };

  const GetFileExtension = (url) => {
    if (!url) return '';
    const name = url.split('/').pop();
    return name?.split('.').pop()?.toLowerCase() || '';
  };
  //#endregion

  return (
    <div className="wrap">
      <M_TBS_CUSTOM
        userInfo={userInfo}
        selectedType={selectedType}
        HandleSelectType={HandleSelectType}
        ActiveButton={props.ActiveButton}
        selectedVideo={selectedVideo}
        selectedEducation={selectedEducation}
        selectedWorkplan={selectedWorkplan}
        SaveLogic1={SaveLogic1}
        listDialogOpen={listDialogOpen}
        setListDialogOpen={setListDialogOpen}
        listData={listData}
        listTitle={listTitle}
        HandleSelectItem={HandleSelectItem}
        previewDialogOpen={previewDialogOpen}
        setPreviewDialogOpen={setPreviewDialogOpen}
        previewItem={previewItem}
        setPreviewItem={setPreviewItem}
        HandleConfirmPreview={HandleConfirmPreview}
        GetFileUrl={GetFileUrl}
        GetFileExtension={GetFileExtension}
        videoRef={videoRef}
      />
    </div>
  );
}

export default M_TBS_CUSTOMF;
